var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_909_2631)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3572 20.5226C19.8067 19.3229 19.7097 14.1729 19.7078 14.043V10.588C19.7078 7.26274 17.7572 4.40338 14.9852 3.1859C14.9792 1.47629 13.6425 0.0874023 12.0001 0.0874023C10.3576 0.0874023 9.02095 1.47638 9.01495 3.18581C6.2431 4.4033 4.29239 7.26266 4.29239 10.5879V14.0429C4.29059 14.1728 4.19349 19.3228 1.64293 20.5226C1.35238 20.6593 1.1927 20.9887 1.25987 21.3134C1.32697 21.6381 1.60262 21.87 1.92148 21.87H8.38738C8.51993 22.6296 8.86471 23.3362 9.39204 23.9086C10.0924 24.6687 11.0187 25.0873 12 25.0873C12.9813 25.0873 13.9076 24.6687 14.6079 23.9086C15.1353 23.3362 15.4801 22.6295 15.6126 21.87H22.0785C22.3973 21.87 22.6729 21.6382 22.7401 21.3134C22.8074 20.9887 22.6478 20.6593 22.3572 20.5226ZM18.9975 18.0555C19.2656 18.9023 19.6452 19.7526 20.1836 20.4602H3.81651C4.35478 19.7527 4.73443 18.9024 5.00255 18.0555H18.9975ZM12.0001 1.49733C12.743 1.49733 13.3712 2.01735 13.5677 2.72617C13.0614 2.61678 12.5371 2.5591 12.0001 2.5591C11.4631 2.5591 10.9388 2.61674 10.4324 2.72617C10.629 2.01739 11.2572 1.49733 12.0001 1.49733ZM5.64592 14.0472V10.5879C5.64592 6.93823 8.49636 3.96903 12.0001 3.96903C15.5038 3.96903 18.3543 6.93823 18.3543 10.5879V14.053C18.3552 14.159 18.371 15.2735 18.6406 16.6455H5.35937C5.62918 15.2722 5.6451 14.1558 5.64592 14.0472ZM12.0001 23.6775C10.9671 23.6775 10.0656 22.9017 9.7762 21.8701H14.2239C13.9345 22.9017 13.0331 23.6775 12.0001 23.6775Z",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 4.95801C9.08814 4.95801 6.71924 7.42554 6.71924 10.4586C6.71924 10.8479 7.02226 11.1636 7.39602 11.1636C7.76979 11.1636 8.07281 10.8479 8.07281 10.4586C8.07281 8.20299 9.8345 6.36794 12 6.36794C12.3737 6.36794 12.6767 6.05229 12.6767 5.66295C12.6767 5.27357 12.3737 4.95801 11.9999 4.95801Z",
    fill: "#858585"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_909_2631"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 25,
    fill: "white",
    transform: "translate(0 0.0874023)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestions);
export default __webpack_public_path__ + "static/media/questions.5771cb0f71b618badf31fe59692c2af1.svg";
export { ForwardRef as ReactComponent };